import { render, staticRenderFns } from "./ImportExcel.vue?vue&type=template&id=2d9338f2&scoped=true&"
import script from "./ImportExcel.vue?vue&type=script&lang=ts&"
export * from "./ImportExcel.vue?vue&type=script&lang=ts&"
import style0 from "./ImportExcel.vue?vue&type=style&index=0&id=2d9338f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9338f2",
  null
  
)

export default component.exports